import RecordsPage from "../records/RecordsPage";

export default function Floors() {
  return <RecordsPage featureKey="floors" />;
}
